<form  [formGroup]="underutilization">
  <!-- {{underutilization.value | json}} -->
<vue-text-input
    label="{{ 'label.alerts' | translate | async }}"
    formControlName="alertname"
    [required]="true"

  ></vue-text-input>
   <vue-select
    label="{{ 'title.queue' | translate | async }}"
    [required]="true"
    formControlName="Queue"
    [options]="queues"
    [getOptionDisplay]="getQueueDisplay"
  ></vue-select>
  <h1>Alert Condition</h1>
  <app-alert-condition formControlName="Time"></app-alert-condition>
 

  <!-- <h1>Utilization Evaluation</h1>
  <div style="display: flex; align-items: baseline;">
     <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Across full date range:</mat-radio-button>
        <mat-radio-button value="2">Per day:</mat-radio-button>
        <mat-radio-button value="3">Per time slot:</mat-radio-button>
        </mat-radio-group>

  </div> -->
  <div style="display: flex; margin-top: 32px; align-items: baseline;">
    <h2>Execution Time*:</h2>
    <vue-image-tooltip  imageSrc="/assets/icons/icon-exclamation.svg"
          content="{{ 'tooltip.message.underutlization.executive.hours' | translate | async }}"></vue-image-tooltip>
    <!-- <vue-select class="depo"
    formControlName="executive"
    [required]="true"
  ></vue-select> -->
      <vue-select class="select_width"
                 
                  label="{{ 'label.placeholder.startTime' | translate | async }}"
                  formControlName="executive" [required]="true" [options]="utcStartTimes"
                  [getOptionDisplay]="addUTCToTime.bind(this)"
                  [errorMatcher]="suppressErrorState"></vue-select>
  </div>

  <div style="display: flex; align-items: baseline; margin-top: -11px;" >
    <h2>Email*:</h2>
     <mat-form-field appearance="outline" style="width:290px; margin-left: 12px;">
        <input matInput type="text" placeholder="Email" formControlName="Email">
    </mat-form-field>
  </div>
</form>

